/* eslint-disable react/prop-types */
import React from "react";
import TextInput from "../../../../component/input/TextInput";
import HeaderTag from "../../../../component/smallComponents/HeaderTag";

function UploadPhotos({ getImagesUrl, dprScreenshots }) {
  return (
    <div className="row">
      <div className="col-md-4 col-xl-4 col-lg-4">
        <div className="mb-5">
          <HeaderTag
            type="h4"
            isClassName={false}
            title="Add photos of your Query"
          />
          <TextInput
            multiple
            type="file"
            file={true}
            required={false}
            textWhite={false}
            htmlFor="dprImages"
            label="Add photos here"
            onChange={(e) => getImagesUrl(e.target.files)}
          />
        </div>
      </div>
      <div className="col-md-12 col-xl-12 col-lg-12">
        {dprScreenshots.map((dprScreenshot, index) => (
          <img
            src={dprScreenshot}
            className="img-thumbnail mr-2"
            style={{
              height: "200px",
              width: "200px"
            }}
            key={index}
          />
        ))}
      </div>
    </div>
  );
}

export default UploadPhotos;
